module.exports = __webpack_public_path__ + "static/media/icon-facebook.a7383764.svg";